export const DEFAULT_UPCOMING_MONTHS = 3;

const parseDateOnly = (value) => {
  if (!value) return null;

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;

  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const flattenUpcomingCalendarGroups = (
  groups,
  { today = new Date(), months = DEFAULT_UPCOMING_MONTHS } = {}
) => {
  const windowStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const windowEnd = new Date(
    windowStart.getFullYear(),
    windowStart.getMonth() + months,
    windowStart.getDate()
  );

  return (Array.isArray(groups) ? groups : [])
    .flatMap((group) =>
      (Array.isArray(group.arrSchedule) ? group.arrSchedule : []).map((schedule) => ({
        ...group,
        eventId: schedule.eventId,
        title: schedule.title || group.title || '',
        startDate: schedule.startDate || group.startDate || '',
        arrSchedule: [schedule],
      }))
    )
    .filter((event) => {
      const scheduleDate = parseDateOnly(event.arrSchedule[0]?.startDate || event.startDate);
      return scheduleDate && scheduleDate >= windowStart && scheduleDate < windowEnd;
    })
    .sort((left, right) => {
      const leftDate = parseDateOnly(left.arrSchedule[0]?.startDate || left.startDate);
      const rightDate = parseDateOnly(right.arrSchedule[0]?.startDate || right.startDate);
      const dateDifference = leftDate.getTime() - rightDate.getTime();
      if (dateDifference !== 0) return dateDifference;
      return Number(left.arrSchedule[0]?.scheduleId || 0) - Number(right.arrSchedule[0]?.scheduleId || 0);
    });
};
